
const initialState = null;

const updateReduxStore = (state = initialState, action) => {
  // const context = await getContext();
  // state = context;

  switch (action.type) {
    case "ADD_USER":
      state = action.payload;
      return state;

    case "UPDATE_ROLE":
      state.loggedInAs = action.payLoad;
      // await addContextToLocalStorage(state);
      return state;

    case "DELETE_USER":
      state = null;
      return state;

    default:
      // if (context != undefined) {
      return state;
    // }
    // return {};
  }
};
export default updateReduxStore;